import http from '../shared/HttpCommon';
import { CommunityManagement } from '../shared/interfaces/ICommunityManagement';
import { Dispatch, SetStateAction } from 'react';
import { CanceledError } from 'axios';

const getCommunityManagementSettings = async (signal: AbortSignal) => {
  try {
    const { data } = await http.get('/user/settings', { signal });
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      console.error(error);
    }
  }
};

const saveCommunityManagementSettings = async (
  communityManagement: CommunityManagement,
  loading: Dispatch<SetStateAction<boolean>>
) => {
  try {
    loading(true);
    await http.patch('/user/settings', { communityManagement });
    loading(false);
  } catch (error) {
    loading(false);
    console.error(error);
  }
};

const saveUserSettings = async (all: any, loading: Dispatch<SetStateAction<boolean>>) => {
  try {
    loading(true);
    await http.patch('/user/settings', all);
    loading(false);
  } catch (error) {
    loading(false);
    console.error(error);
  }
};

const UserService = {
  getCommunityManagementSettings,
  saveCommunityManagementSettings,
  saveUserSettings,
};

export default UserService;
